import { Button, Form, Col, Offcanvas, Row, Card } from "react-bootstrap";
import { Controller, set, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import HelperService from "../../utility/HelperService";
import WebService from "../../utility/WebService";
import { Label } from "../../components/Label/Label";
import Select from "react-select";
import PlotDatePicker from "../../components/PlotDatePicker/PlotDatePicker";
import UploadFile from "../../components/UploadFile/UploadFile";
import { IoClose } from "react-icons/io5";
import DocIcon from "../../assets/images/doc-icon.svg";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: any;
    isRed: boolean;
    projectList?: any[];
    vendorList?: any[];
}

interface formInterface {
    id: number
    uuid?: string
    user_id: number
    project_id?: number | null
    title: string
    type: 'BANKING' | 'INDIVIDUAL'
    status: 'ACTIVE' | 'DELETED' | 'PAID'
    payment_mode: 'CASH' | 'CHEQUE' | 'ONLINE'
    utr_number?: string | null
    amount?: number | null
    token_id?: string | null
    paid_amount?: number | null
    internal_loan_id?: string | null
    file_name?: string | null
    comment?: string | null
    rate_of_interest?: number | null
    loan_duration: number
    start_date?: Date
    end_date?: Date
    interest_type: 'PRE' | 'POST' | 'MIXED'
    created_at?: Date
    updated_at?: Date
}

interface loanEmiInterface {
    id: number
    uuid: string
    project_id?: number | null
    loan_id: number
    name: string
    status: 'PENDING' | 'OVERDUE' | 'PAID'
    amount?: number | null
    internal_loan_emi_id?: string | null
    emi_date?: Date | null
    created_at?: Date
}

let paymentModeOptions: any[] = [];

const AddLoan = (props: PropData) => {
    const { handleSubmit, formState: { errors }, control, watch, reset, setValue, register } = useForm<formInterface>({});
    const watchAllFields = watch();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [projectList, setProjectList] = useState<any[]>([]);
    const loanTypeList = [{ value: "BANKING", label: "Banking" }, { value: "INDIVIDUAL", label: "Individual" }];
    const interestTypeList = [{ value: "PRE", label: "Pre" }, { value: "POST", label: "Post" }, { value: "MIXED", label: "Mixed" }];
    const initialEmiState: loanEmiInterface = { id: new Date().getTime(), uuid: "", loan_id: 0, name: "", status: "PENDING" };
    const [emis, setEmis] = useState<loanEmiInterface[]>([initialEmiState]);

    useEffect(() => {
        props.projectList && setProjectList(props.projectList);
    }, [props.projectList, props.vendorList]);

    useEffect(() => {
        if (props.isShow) {
            if (props.data && !HelperService.isEmptyObject(props.data)) {
                setValue("id", props.data.id);
                setValue("uuid", props.data.uuid);
                setValue("project_id", props.data.project_id);
                reset(props.data);
                setEmis(props.data.emis);
                setIsEdit(true);
            } else {
                reset({});
                resetForm();

                setIsEdit(false);
            }
            if (props.isRed) {
                paymentModeOptions = [
                    { value: "CASH", label: "Cash" },
                    { value: "CHEQUE", label: "Cheque" },
                    { value: "ONLINE", label: "Online" }
                ]
            } else {
                paymentModeOptions = [
                    { value: "CHEQUE", label: "Cheque" },
                    { value: "ONLINE", label: "Online" }
                ]
            }
        }
    }, [props.isShow, props.data]);

    const handleFormSubmit = (data: formInterface) => {
        const url = isEdit ? `loan/update` : "loan/create";
        WebService[isEdit ? "putAPI" : 'postAPI']({
            action: url, body: { ...data, emis: emis }, id: "changePassword-btn", is_session: props.isRed
        }).then((res: any) => {
            toast.success(res.message);
            closeModal(true);
        }).catch(() => { });
    };

    const closeModal = (e: boolean) => {
        reset();
        resetForm();
        props.isClose(e);
    };

    const resetForm = () => {
        reset({});
        setValue("project_id", null as any)
    };

    const getSignedUrl = (fileName: string) => {
        WebService.postAPI({ action: "get/signed-url", body: { key: `projects/${fileName}` } })
            .then((res: any) => {
                if (res && res.signed_url) {
                    window.open(res.signed_url, "_blank");
                } else {
                    toast.error("Failed to get signed URL");
                }
            })
            .catch((error: any) => { toast.error("Failed to get signed URL"); });
    };

    const onDeleteImage = () => {
        setValue("file_name", "");
    };

    const onUploadFile = (data: any, name: string, size: string) => {
        uploadFile(data);
    };

    const uploadFile = (data: any) => {
        WebService.fileUploadAPI({ action: `upload/file`, key: "image", file: data, body: { type: "PROJECT" }, id: "changePassword-btn" })
            .then(async (res: any) => {
                toast.success("File uploaded successfully");
                setValue("file_name", res.file_name);
            })
            .catch(async (error: any) => { });
    };

    return (
        <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas-large">
            <Offcanvas.Header closeButton><Offcanvas.Title>{isEdit ? "Edit Loan" : "Add Loan"}</Offcanvas.Title></Offcanvas.Header>
            <Offcanvas.Body className="form-style">
                <form className="form-style" onSubmit={handleSubmit(handleFormSubmit)}  >
                    <Row>
                        <Col lg={6} md={6} sm={12} className="mb-3">
                            {/* type */}
                            <Controller
                                control={control}
                                name="type"
                                rules={{ required: true }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Loan Type</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <Select
                                                className="basic-single w-100"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                options={loanTypeList}
                                                onChange={(e: any) => { onChange(e.value); (e.value == "BANKING" && setValue("interest_type", "MIXED")) }}
                                                value={loanTypeList?.find((option: any) => option.value === watchAllFields.type)}
                                                placeholder="Select Loan Type"
                                            />
                                        </div>
                                        {errors.type && (<div className="login-error mb-3"> <Label title={"Please select loan type"} modeError={true} /> </div>)}
                                    </Form.Group>
                                )}
                            />

                            {/* title */}
                            <div className="d-flex">
                                <Form.Group className="mb-2 w-100">
                                    <Form.Label>Title</Form.Label>{" "}
                                    <span className="text-danger">*</span>
                                    <div className="input-group mb-1">
                                        <input type="text" className="form-control ps-3 p-2" placeholder={"Title"} {...register("title", { required: true })} value={watchAllFields.title} />
                                    </div>
                                    {errors.title && (<div className="login-error mb-3"> <Label title={"Please enter title"} modeError={true} /> </div>)}
                                </Form.Group>
                            </div>

                            {/* amount */}
                            <Form.Group className="mb-3">
                                <Form.Label>Principal Amount</Form.Label>{" "}
                                <span className="text-danger">*</span>
                                <div className="input-group mb-1">
                                    <input type="text" className="form-control ps-3 p-2" placeholder={"Amount"} {...register("amount", { required: true })} onKeyPress={HelperService.allowNewDecimalValue} value={watchAllFields.amount as any} />
                                </div>
                                {errors.amount && (<div className="login-error mb-3"> <Label title={"Please enter amount"} modeError={true} /> </div>)}
                            </Form.Group>

                            {/* loan_duration */}
                            <Form.Group className="mb-3">
                                <Form.Label>Loan Duration ( In Months )</Form.Label>{" "}
                                <div className="input-group mb-1">
                                    <input type="text" className="form-control ps-3 p-2" placeholder={"Loan Duration"} {...register("loan_duration", { required: false })} onKeyPress={HelperService.allowNewDecimalValue} value={watchAllFields.loan_duration as any} />
                                </div>
                            </Form.Group>

                            {/* start_date */}
                            <Controller
                                control={control}
                                name="start_date"
                                rules={{ required: true, }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Start Date</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <div className="col-12 form-group">
                                                <PlotDatePicker
                                                    selected={watch("start_date") ? new Date(watch("start_date") as any) : null}
                                                    onChange={(date: any) => onChange(date)}
                                                    placeholderText="Select Date"
                                                />
                                                {errors.start_date && (<Label title={"Please Select Start Date."} modeError={true} />)}
                                            </div>
                                        </div>
                                    </Form.Group>
                                )}
                            />

                            {/* paid_amount */}
                            {props.data && props?.data?.id &&
                                <Form.Group className="mb-3">
                                    <Form.Label>Paid Amount</Form.Label>{" "}
                                    <div className="input-group mb-1">
                                        <input type="text" className="form-control ps-3 p-2" placeholder={"Paid Amount"} {...register("paid_amount", { required: false })} onKeyPress={HelperService.allowNewDecimalValue} value={watchAllFields.paid_amount as any} />
                                    </div>
                                </Form.Group>
                            }

                        </Col>

                        <Col lg={6} md={6} sm={12} className="mb-3">
                            {/* project_id */}
                            <Controller
                                control={control}
                                name="project_id"
                                rules={{ required: false }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Project</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <Select
                                                className="basic-single w-100"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                options={projectList}
                                                onChange={(e: any) => { onChange(e.value); }}
                                                value={projectList?.find((option: any) => option.value === watchAllFields.project_id)}
                                                placeholder="Select Project"
                                            />
                                        </div>
                                        {errors.project_id && (<div className="login-error mb-3"> <Label title={"Please select project"} modeError={true} /> </div>)}
                                    </Form.Group>
                                )}
                            />

                            {/* payment_mode */}
                            <Controller
                                control={control}
                                name="payment_mode"
                                rules={{ required: true }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Payment Mode</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <Select
                                                className="basic-single w-100"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                options={paymentModeOptions}
                                                onChange={(e: any) => { onChange(e.value); }}
                                                value={paymentModeOptions?.find((option: any) => option.value === watchAllFields.payment_mode)}
                                                placeholder="Select Payment Mode"
                                            />
                                        </div>
                                        {errors.payment_mode && (<div className="login-error mb-3"> <Label title={"Please select payment mode"} modeError={true} /> </div>)}
                                    </Form.Group>
                                )}
                            />

                            {/* interest_type */}
                            <Controller
                                control={control}
                                name="interest_type"
                                rules={{ required: true }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Interest Type</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <Select
                                                className="basic-single w-100"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                options={interestTypeList}
                                                onChange={(e: any) => { onChange(e.value); }}
                                                value={interestTypeList?.find((option: any) => option.value === watchAllFields.interest_type)}
                                                placeholder="Select Interest Type"
                                                isDisabled={watchAllFields.type === "BANKING" ? true : false}
                                            />
                                        </div>
                                        {errors.interest_type && (<div className="login-error mb-3"> <Label title={"Please select interest type"} modeError={true} /> </div>)}
                                    </Form.Group>
                                )}
                            />

                            {/* utr_number */}
                            {(watchAllFields.payment_mode === "CHEQUE" || watchAllFields.payment_mode === "ONLINE") && <Form.Group className="mb-3">
                                <Form.Label>UTR Number</Form.Label>  <span className="text-danger">*</span>
                                <div className="input-group mb-1">
                                    <input type="text" className="form-control ps-3 p-2" placeholder="UTR Number" {...register("utr_number", { required: true })} />
                                </div>
                                {errors.utr_number && (<div className="login-error mb-3"> <Label title={"Please enter utr number"} modeError={true} /> </div>)}
                            </Form.Group>}

                            {/* rate_of_interest */}
                            <Form.Group className="mb-3">
                                <Form.Label>Rate of Interest</Form.Label>{" "}
                                <div className="input-group mb-1">
                                    <input type="text" className="form-control ps-3 p-2" placeholder={"Rate of Interest"} {...register("rate_of_interest", { required: false })} onKeyPress={HelperService.allowNewDecimalValue} value={watchAllFields.rate_of_interest as any} />
                                </div>
                            </Form.Group>

                            {/* end_date */}
                            <Controller
                                control={control}
                                name="end_date"
                                rules={{ required: true, }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>End Date</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <div className="col-12 form-group">
                                                <PlotDatePicker
                                                    selected={watch("end_date") ? new Date(watch("end_date") as any) : null}
                                                    onChange={(date: any) => onChange(date)}
                                                    minData={watchAllFields.start_date ? new Date(watchAllFields.start_date) : new Date()}
                                                    placeholderText="Select Date"
                                                />
                                                {errors.end_date && (<Label title={"Please Select End    Date."} modeError={true} />)}
                                            </div>
                                        </div>
                                    </Form.Group>
                                )}
                            />

                            {/* status */}
                            {props.data && props?.data?.id &&
                                <Form.Check type="switch" id="custom-switch" label="Mark as Paid" {...register("status", { value: "ACTIVE" })} className="pt-1" checked={watchAllFields.status ? Boolean(watchAllFields.status === "PAID") : false} />
                            }
                        </Col>

                        {!watchAllFields.file_name && <div className="px-3"> <UploadFile
                            key={new Date().getTime()}
                            onChange={(data: any, name: string, size: string) => { onUploadFile(data, name, size); }}
                            acceptFileType={["jpg", "jpeg", "pdf", "png"]}
                            message="Upload or Drag and Drop Loan Document here"
                            acceptedSize={5}
                        /> </div>}

                        {(watchAllFields.file_name) &&
                            <div className="px-3">
                                <Card className={`border p-2 d-inline-block px-3 mb-3 me-2 h-auto`}>
                                    <div className="d-flex gap-3 align-items-center">
                                        <div className="me-1">
                                            <IoClose size={20} onClick={() => { onDeleteImage(); }} className="text-secondary opacity-50 hover-effect cursor-pointer close" />
                                        </div>
                                        <div> <img src={DocIcon} width={40} height={40} alt="" /> </div>
                                        <div>
                                            <p className="font-medium font-16 mb-0 cursor-pointer" onClick={() => getSignedUrl(watchAllFields.file_name || "")}>  {watchAllFields.file_name} </p>
                                        </div>
                                    </div>
                                </Card>
                            </div>}
                    </Row>
                    {/* // EMI Section */}
                    <div className="mb-3 border-top pt-2 mt-2">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5>EMI Details</h5>
                            <Button variant="primary" className="btn-sm" onClick={() => setEmis([...emis, initialEmiState])}>Add EMI</Button>
                        </div>
                        {emis && emis.length > 0 && <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>EMI Name</th>
                                        <th>EMI Date</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {emis.map((emi: loanEmiInterface, index: number) => (
                                        <tr key={index}>
                                            <td>
                                                <input type="text" className="form-control ps-3 p-2" placeholder={"EMI Name"} value={emi.name} onChange={(e) =>
                                                    setEmis(emis.map((_: loanEmiInterface, i: number) => i === index ? { ..._, name: e.target.value } : _))
                                                } />
                                            </td>
                                            <td>
                                                <PlotDatePicker
                                                    selected={emi.emi_date ? new Date(emi.emi_date as any) : null}
                                                    onChange={(date: any) => setEmis(emis.map((_: loanEmiInterface, i: number) => i === index ? { ..._, emi_date: date } : _))}
                                                    placeholderText="Select Date"
                                                />
                                            </td>
                                            <td>
                                                <input type="text" className="form-control ps-3 p-2" placeholder={"Amount"} value={emi.amount as any} onKeyPress={HelperService.allowNewDecimalValue} onChange={(e) =>
                                                    setEmis(emis.map((_: loanEmiInterface, i: number) => i === index ? { ..._, amount: e.target.value ? parseFloat(e.target.value) : null } : _))
                                                } />
                                            </td>
                                            <td>
                                                <select className="form-select" value={emi.status} onChange={(e) =>
                                                    setEmis(emis.map((_: loanEmiInterface, i: number) => i === index ? { ..._, status: e.target.value as any } : _))
                                                }>
                                                    <option value="PENDING">Pending</option>
                                                    <option value="OVERDUE">Overdue</option>
                                                    <option value="PAID">Paid</option>
                                                </select>
                                            </td>
                                            <td>
                                                <Button variant="danger" className="btn-sm" onClick={() => setEmis(emis.filter((_: loanEmiInterface, i: number) => i !== index))}>Delete</Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>}
                    </div>
                    <div className="text-center border-top">
                        <Button variant="dark" className="btn-brand-1 px-5 mt-3 mb-3 me-2" type="submit" id="changePassword-btn">{isEdit ? "Update" : "Add"}</Button>
                        <Button variant="light" className="btn-brand-1 px-5 mt-3 mb-3" type="button" onClick={() => closeModal(false)}>Close</Button>
                    </div>
                </form>
            </Offcanvas.Body>
        </Offcanvas >
    );
};

export default AddLoan;
